import 'slick-carousel'
import 'lazysizes'
import PortalVue from 'portal-vue'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import VueSmoothScroll from 'vue2-smooth-scroll'

import stickyHeader from './modules/stickyHeader'
import anchorNav from "./modules/anchorNav"

// Directives
import animate from './directives/animate'

import "./modules/marketo"
import "./helpers/inlineScriptFix"

import BpAccordion from '../styles/molecules/accordion/BpAccordion'
import BpCarousel from '../styles/organisms/carousel/BpCarousel'
import BpClickable from '../styles/utilities/clickable/BpClickable'
import BpDirectional from '../styles/utilities/directional/BpDirectional'
import BpDismissable from '../styles/utilities/dismissable/BpDismissable'
import BpDropdown from '../styles/atoms/dropdown/BpDropdown'
import BpMobileNavigation from '../styles/organisms/mobile-navigation/BpMobileNavigation'
import BpModal from '../styles/organisms/modal/BpModal'
import BpTabs from '../styles/molecules/tabs/BpTabs'
import DropdownMenu from '../styles/molecules/dropdown-menu/DropdownMenu'

import Vue from 'vue'

import Filtering from './filtering.js'

Vue.use(PortalVue)
Vue.use(VueSmoothScroll)

new Vue({
    el: '#root',
    mixins: [ Filtering ],
    components: {
        'simplebar': () => import('simplebar-vue'),

        BpAccordion,
        BpCarousel,
        BpClickable,
        BpDirectional,
        BpDismissable,
        BpDropdown,
        BpMobileNavigation,
        BpModal,
        BpTabs,
        DropdownMenu,
        Swiper,
        SwiperSlide,
    },
    directives: {
        animate
    },
    mounted() {
        stickyHeader()
        anchorNav()
    }
})

